<div *nzModalTitle>
  <h3 class="mb-0">Calendar</h3>
</div>

<ng-container>

  <full-calendar *ngIf="showCalendar" [deepChangeDetection]="true"  [options]="calendarOptions"></full-calendar>

</ng-container>
